// @flow
import * as React from 'react';

import { ProcModal, Button, Footer } from '@sonyged/ext-proc';

import Avatar1Off from '../../assets/images/pages/top/choose_avater_off_01@3x.png';
import Avatar1On from '../../assets/images/pages/top/choose_avater_on_01@3x.png';
import Avatar2Off from '../../assets/images/pages/top/choose_avater_off_02@3x.png';
import Avatar2On from '../../assets/images/pages/top/choose_avater_on_02@3x.png';
import Avatar3Off from '../../assets/images/pages/top/choose_avater_off_03@3x.png';
import Avatar3On from '../../assets/images/pages/top/choose_avater_on_03@3x.png';

type Props = {
  isOpened: boolean,
  onSelect: string => void,
  avatar: ?string,
};

type State = {
  avatar: ?string,
};

class AvatarSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      avatar: props.avatar,
    };
  }

  handleStartClicked = () => {
    if (!this.state.avatar) return;

    this.props.onSelect(this.state.avatar);
  };

  render() {
    return (
      <ProcModal rootNodeId="proc-index-page-root" isOpened={this.props.isOpened}>
        <div className="proc-modal avatar-selector">
          <div className={'proc-modal-container'}>
            <div className="proc-modal-header proc-huge-font gray100-color">あなたの すがたを えらぼう</div>
            <div className="proc-modal-contents">
              <div className="avatars">
                <img
                  className={`proc-hover ${this.state.avatar === '1' ? 'selected' : ''}`}
                  src={this.state.avatar === '1' ? Avatar1On : Avatar1Off}
                  onClick={() => {
                    this.setState({ avatar: '1' });
                  }}
                />
                <img
                  className={`proc-hover ${this.state.avatar === '2' ? 'selected' : ''}`}
                  src={this.state.avatar === '2' ? Avatar2On : Avatar2Off}
                  onClick={() => {
                    this.setState({ avatar: '2' });
                  }}
                />
                <img
                  className={`proc-hover ${this.state.avatar === '3' ? 'selected' : ''}`}
                  src={this.state.avatar === '3' ? Avatar3On : Avatar3Off}
                  onClick={() => {
                    this.setState({ avatar: '3' });
                  }}
                />
              </div>
            </div>
            <Footer.normal shadow={false}>
              <Button.attention disabled={!this.state.avatar} onClick={this.handleStartClicked}>
                けってい
              </Button.attention>
            </Footer.normal>
          </div>
        </div>
      </ProcModal>
    );
  }
}

export default AvatarSelector;
